import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function PartnersSection() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPartners = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/about/partners`);
      setPartners(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching partners:", err);
      setPartners([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartners();
  }, []);

  return (
    <section className="bg-gradient-to-br from-slate-50 to-slate-100 py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Our Partners
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            The leadership team that defines HPR Infra’s vision, values, and commitment
            to building enduring real estate excellence.
          </p>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="text-center text-slate-600 text-lg py-10">
            Loading partners...
          </div>
        )}

        {/* No Data State */}
        {!loading && partners.length === 0 && (
          <div className="text-center text-slate-600 text-lg py-10 italic">
            No partners added yet.
          </div>
        )}

        {/* Partner Cards */}
        {!loading && partners.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-8 md:gap-10 justify-items-center">

            {partners.map((partner, index) => (
              <div
                key={partner.partner_id || index}
                className="
                  bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 
                  flex flex-col h-full 
                  mx-auto 
                  w-full 
                  max-w-[330px] sm:max-w-[360px] md:max-w-[380px] 
                "
              >
                {/* Image */}
                <div className="w-full h-64 overflow-hidden rounded-t-xl">
               <img
               src={partner.image}
               alt={partner.name}
              className="w-full h-full object-cover object-center transform hover:scale-105 transition-transform duration-500"
               />
              </div>
                {/* Text */}
                <div className="p-5 sm:p-6 flex flex-col flex-grow text-center sm:text-left space-y-3">
                  <h2 className="text-lg sm:text-xl font-bold text-slate-900">
                    {partner.name}
                  </h2>
                  <p className="text-sm sm:text-base font-semibold text-blue-900">
                    {partner.role}
                  </p>
                <p className="text-sm sm:text-[15px] md:text-base text-slate-700 leading-relaxed flex-grow text-justify">
                    {partner.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}